var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBasketballPracticeProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.25,
    height: 23.25,
    viewBox: "0 0 23.25 23.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143568",
    "data-name": "Path 143568",
    d: "M11.625-20.625A11.62,11.62,0,0,0,0-9,11.614,11.614,0,0,0,11.625,2.625,11.617,11.617,0,0,0,23.25-9,11.617,11.617,0,0,0,11.625-20.625ZM10.973.342A9.35,9.35,0,0,1,5.845-1.627l5.78-5.78,2.016,2.016A12.378,12.378,0,0,0,10.973.342Zm4.289-4.111L17.4-1.627A9.329,9.329,0,0,1,13.317.216,10.142,10.142,0,0,1,15.262-3.769Zm1.594-1.589A10.035,10.035,0,0,1,20.845-7.3,9.258,9.258,0,0,1,19-3.211Zm4.111-4.294A12.449,12.449,0,0,0,15.23-6.98L13.214-9l5.78-5.784A9.235,9.235,0,0,1,20.967-9.652ZM6.516-12.516a10.074,10.074,0,0,1-4.13,1.973A9.317,9.317,0,0,1,4.252-14.78Zm-.67-3.858a9.278,9.278,0,0,1,4.233-1.866A10.074,10.074,0,0,1,8.1-14.109Zm6.572-1.964A9.291,9.291,0,0,1,17.4-16.373l-5.78,5.784L9.731-12.483A12.381,12.381,0,0,0,12.417-18.337ZM2.287-8.2a12.388,12.388,0,0,0,5.85-2.686L10.031-9l-5.78,5.78A9.32,9.32,0,0,1,2.287-8.2Z",
    transform: "translate(0 20.625)",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasketballPracticeProblem);
export default __webpack_public_path__ + "static/media/Icon-Basketball-PracticeProblem.4f143fd4273829cb51b070f76f9ce4e0.svg";
export { ForwardRef as ReactComponent };